import { useEffect } from 'react';

import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';
import { initializeControls } from '@atlassian/browser-storage-controls';
import { useFeatureGate } from '@atlassian/feature-gates-react';

export const InitializeWebStorageControls = () => {
  const hasWebStorageControls = useFeatureGate(
    StatsigFeatureKeys.webStorageControls
  );

  useEffect(() => {
    // initializeControls only supports initialization with a value(true/false) once,
    // so we set it to true only when necessary; otherwise, we provide undefined.
    initializeControls({
      product: 'Bitbucket',
      webStorageEnabled: hasWebStorageControls === true ? true : undefined,
    });
  }, [hasWebStorageControls]);

  return null;
};
